import React, { Suspense } from "react";
import "./App.css";

import * as Sentry from "@sentry/react";
import { connect } from "react-redux";
//Components
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MailIcon from "@material-ui/icons/Mail";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import { Helmet } from "react-helmet";
import { Route, Switch, withRouter } from "react-router-dom";
import Header from "./Components/Header";
import HomePage from "./Components/HomePage";
import ProductDetails from "./Components/ProductDetails";
// import Loading from "./Components/Loading";
import Branches from "./Components/Branches";
import Confirmation from "./Components/CheckoutProcess/Confirmation";
import FirstStep from "./Components/CheckoutProcess/FirstStep";
import SecondStep from "./Components/CheckoutProcess/SecondStep";

// import BranchDetail from "./Components/Branches/BranchDetail";
import BranchDetail from "./Components/AreaSelect/BranchDetails";
import Cart from "./Components/Cart";
import CategoryDetailList from "./Components/GridView/CategoryDetailList";
import Search from "./Components/Search";

import instance from "../src/store/actions/instance";
import NoticeBanner from "./Components/Banner/Notice";
import PopupBanner from "./Components/Banner/Popup";
import PaymentFail from "./Components/CheckoutProcess/PaymentFail";
import PaymentSuccess from "./Components/CheckoutProcess/PaymentSuccess";
import MapPickerPage from "./Components/CheckoutProcess/SecondStep/MapPickerPage";
import DigitalDownload from "./Components/DigitalDownload";
import PastOrders from "./Components/PastOrders";
import Profile from "./Components/Profile";
import Points from "./Components/Profile/Points";
import Wallet from "./Components/Profile/Wallet";
import TrackingPage from "./Components/TrackingPage";
import WaitList from "./Components/WaitList";
import WaitListStatus from "./Components/WaitList/WaitList";
import WaitListForm from "./Components/WaitList/WaitListForm";
import {
  Apply_Promo,
  clearOrderPassData,
  refreshStorefrontOrderPassData,
  saveCustomerContact,
} from "./store/actions";
import { setBranchDeliveryCharge } from "./store/actions/branch";

//B2B
import B2B from "./Components/B2B";
import DistributorFail from "./Components/B2B/Fail";
import DistributorProductDetails from "./Components/B2B/ProductDetails";
import DistributorSuccess from "./Components/B2B/Success";
import DistributorOrderTracking from "./Components/B2B/Tracking";

//Analytics
import googleTagManager from "@analytics/google-tag-manager";
import Analytics from "analytics";
import ReactGA from "react-ga4";
import SnapchatPixel from "react-snapchat-pixel";
import ReactAckoo from "./ackoo";
import PinterestPixel from "./PinterestPixel";
import TiktokPixel from "./tiktok-pixel";
import TwitterPixel from "./TwitterPixel";

//Ads
import GoogleAdsTracker from "./GoogleAdsTracker";
import Klaviyo from "./Klaviyo";

//Assets
import {
  createMuiTheme,
  ThemeProvider as MuiThemeProvider,
} from "@material-ui/core/styles";

//Actions
import SignUpModal from "./Components/common/SignUpModal";
import {
  fetchBranch,
  fetchStore,
  resetLocalStorage,
  setLanguage,
} from "./store/actions";
import {
  createCustomerWithAddressAndPhone,
  setUser,
} from "./store/actions/auth";
import { clearCart, loadCart } from "./store/actions/cart";

import WhatsAppWidget from "./Components/WhatsAppWidget";

import AreaSelect from "./Components/AreaSelect";
import WalletTopupProcess from "./Components/WalletTopupProcess";

import Fab from "@material-ui/core/Fab";
import Snackbar from "@material-ui/core/Snackbar";
import RoomServiceIcon from "@material-ui/icons/RoomService";
import MuiAlert from "@material-ui/lab/Alert";

import CallWaiterDiolog from "./Components/CallWaiterDialog";
import EbutlerWidget from "./Components/EbutlerWidget";
import InstagramWidget from "./Components/InstagramWidget";
import EmailForgotPassword from "./Components/Profile/EmailForgotPassword";
import EmailSignin from "./Components/Profile/EmailSignin";
import PromotionMessage from "./Components/Promotions/PromotionMessage";
import TikTokWidget from "./Components/TikTokWidget";

import FavoriteProductPage from "./Components/ProductDetails/FavoriteProducts/FavoriteProductPage";
import PhoneForgotPassword from "./Components/Profile/PhoneForgotPassword";
import PhoneSignin from "./Components/Profile/PhoneSignin";
import ProductFeedbackPage from "./Components/TrackingPage/ProductFeedback/ProductFeedbackPage";
import {
  canAddToCartBeforeBranchSelection,
  canUseSocialAuth,
} from "./Helpers/orderPass";

// Tabs
import Paper from "@material-ui/core/Paper";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { MenuBook, Person, Star } from "@material-ui/icons";
import LoyaltyHomePage from "./Components/PromotionalStoreFront/LoyaltyHomePage";
import Teasers from "./Components/Teasers";
import { EnableFaceBook } from "./Helpers/analytics";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const Loading = React.lazy(() => import("./Components/Loading"));

export let GTM;

function EnableGoogle(ID) {
  ReactGA.initialize(ID);
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname + window.location.search,
  });
  ReactGA.event({
    category: "View Content",
    action: `View Content`,
    label: "View Content",
  });
}

function EnableGoogleTagManager(ID) {
  GTM = Analytics({
    app: "app",
    plugins: [
      googleTagManager({
        containerId: ID,
      }),
    ],
  });
  GTM.page();
  GTM.track("view_content");
}

function EnableAckoo(ID) {
  ReactAckoo.init(ID);
}
function EnableSnapChat(ID, Email) {
  const userIdentification = { user_email: Email }; // optional
  const options = {
    debug: false, // enable logs
  };
  SnapchatPixel.init(ID, userIdentification, options);

  SnapchatPixel.pageView(); // For tracking page view
  SnapchatPixel.track("VIEW_CONTENT", { integration: "ordable" });
}
class App extends React.Component {
  constructor(props) {
    super(props);

    this.selector = React.createRef();
    this.lastOrderPassRefreshKey = null;
  }

  state = {
    signUpModalOpen: false,
    alertOpen: false,
    openWaiterDialog: false,

    currentTab: "homepage",
    lastHomePageLink: "/",
  };

  refreshOrderPassStorefrontData = async () => {
    const { settings, customer } = this.props;
    const verifiedPhone =
      customer?.orderPassVerifiedPhone || customer?.customerContact?.phone;
    const refreshKey = [
      this.props.store?.id || this.props.branch?.branch || "store",
      verifiedPhone || "",
    ].join(":");

    if (!this.props.store) {
      return;
    }

    if (!settings?.enable_orderpass) {
      if (
        customer?.orderPassPhone ||
        customer?.orderPassVerifiedPhone ||
        customer?.orderPassLinked ||
        customer?.orderPassStorefrontToken ||
        customer?.orderPassAddresses?.length ||
        customer?.orderPassGuestBypassPhone
      ) {
        this.props.clearOrderPassData();
      }
      this.lastOrderPassRefreshKey = null;
      return;
    }

    if (!verifiedPhone || this.lastOrderPassRefreshKey === refreshKey) {
      return;
    }

    this.lastOrderPassRefreshKey = refreshKey;
    await this.props.refreshStorefrontOrderPassData();
  };

  fullList = (side) => (
    <div>
      <List>
        <ListItem button>
          <ListItemIcon>
            <MailIcon />
          </ListItemIcon>
          <ListItemText primary={"WhatsApp"} />
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem button>
          <ListItemIcon>
            {" "}
            <InboxIcon />{" "}
          </ListItemIcon>
          <ListItemText primary={"Store"} />
        </ListItem>
      </List>
    </div>
  );

  async componentDidCatch(error, info) {
    const location = window.location.href;
    const isLocalhost = Boolean(
      window.location.hostname === "localhost" ||
      window.location.hostname == "192.168.43.120" ||
      window.location.hostname == "192.168.43.74" ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === "[::1]" ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
      ),
    );
    if (!isLocalhost) {
      let ErrorCount = sessionStorage.getItem("ErrorCount");
      let browserInfo = null;
      try {
        browserInfo = await instance.get(
          "https://www.cloudflare.com/cdn-cgi/trace",
        ).data;
      } catch (e) {
        console.log("Couldnt fetch browserInfo");
      }

      if (ErrorCount) {
        ErrorCount = parseInt(ErrorCount);

        if (ErrorCount >= 2) {
          await this.props.resetLocalStorage();

          let lastError = localStorage.getItem("lastError");

          if (!lastError || Date.now() - parseInt(lastError) > 10000) {
            Sentry.captureException(new Error("Local Storage was reset"));
            await instance.post("send_error/", {
              error: "local storage was reset",
              info: " ",
              browser: browserInfo || navigator.userAgent,
            });
            localStorage.setItem("lastError", String(Date.now()));
          }

          sessionStorage.removeItem("ErrorCount");
        } else {
          sessionStorage.setItem("ErrorCount", ErrorCount + 1);
        }
      } else {
        sessionStorage.setItem("ErrorCount", 1);
      }
      this.props.history.replace("/");
      window.location.reload(true);
      let lastError2 = localStorage.getItem("lastError2");

      if (!lastError2 || Date.now() - parseInt(lastError2) > 10000) {
        Sentry.captureException(error, (scope) => {
          scope.setExtra("cart", JSON.stringify(this.props.main_cart));
          scope.setExtra("branch", JSON.stringify(this.props.branch));
          scope.setExtra("customer", JSON.stringify(this.props.customer));
          scope.setExtra(
            "current_product",
            this.props.current_product
              ? this.props.current_product.name
              : "NONE",
          );
        });
        await instance.post("send_error/", {
          error: error.toString(),
          info: info.componentStack,
          cart_reducer: JSON.stringify(this.props.main_cart),
          branch_reducer: JSON.stringify(this.props.branch),
          customer_reducer: JSON.stringify(this.props.customer),
          current_product: this.props.current_product
            ? this.props.current_product.name
            : "NONE",
          browser: browserInfo || navigator.userAgent,
          path: location,
        });
        localStorage.setItem("lastError2", String(Date.now()));
      }
    }
  }
  TryApplyPromo = async (search) => {
    const params = new URLSearchParams(search);
    const promo_code =
      params.get("promotion") || this.props.applied_promo?.code;

    if (promo_code) {
      let promo = this.props?.store?.promos
        .concat(this.props.store.smart_promos)
        .find((promo) => promo.code === promo_code);
      if (promo) {
        if (promo?.id != this.props.applied_promo?.id) {
          this.props.Apply_Promo(promo);
        }
      } else {
        try {
          promo = await instance.post("coupon/", {
            code: promo_code,
            branch: this.props.branch?.branch,
            channel: this.props.channel,
          });

          this.props.Apply_Promo(promo.data);
        } catch (e) {
          this.props.Apply_Promo();
          sessionStorage.setItem("promo_code", search);
        }
      }
    }
  };

  captureSessionStart = () => {
    try {
      const thisSession = localStorage.getItem("sessionStart");
      if (thisSession) {
        const savedDate = new Date(thisSession);
        const now = new Date();
        const diffMs = now.getTime() - savedDate.getTime();
        const diffMinutes = diffMs / (1000 * 60);
        if (diffMinutes > 60) {
          localStorage.setItem("sessionStart", now.toISOString());
        }
      } else {
        localStorage.setItem("sessionStart", new Date().toISOString());
      }
    } catch (e) {}
  };
  componentDidMount = async () => {
    this.captureSessionStart();
    const paramsLang = new URLSearchParams(window.location.search);
    let language =
      paramsLang.get("lang") ||
      paramsLang.get("language") ||
      localStorage.getItem("language");
    let tn = null;
    if (language) {
      if (language === "en") language = "english";
      else if (language === "ar") language = "arabic";
      else if (!["english", "arabic"].includes(language)) language = "english";
      this.props.setLanguage(language);
    }
    if (!this.props.store) {
      // It goes here after authenticating with google for the first time
      // componentDidMount in /Profile/GoogleAuth.js handles the errors
      // and redirects back to /profile to remove the query params

      // const success = params.get("success");
      const token = paramsLang.get("auth_key");

      if (localStorage.getItem("stoken") && !token) {
        await this.props.setUser(
          localStorage.getItem("stoken"),
          this.props.history,
        );
      } else {
        if (token) {
          this.props.resetCustomersReducer();
          await this.props.setUser(token, this.props.history);
          this.props.history.replace(window.location.pathname, {
            prevPath: "profile",
          });
        }
      }

      const params = new URLSearchParams(window.location.search);
      if (params.get("src") === "haEubKB6T2") {
        this.props.setFromMobile();
      }

      if (params.get("src") === "Q7mZpL2xWa") {
        await this.props.resetLocalStorage();
        localStorage.clear();
        await this.props.resetCustomersReducer();
        await this.props.setUser();
        const userId = params.get("userId");
        localStorage.setItem("orderPlacedById", userId);
        const customerName = params.get("customerName");
        const customerPhone = params.get("customerPhone");
        const customerEmail = params.get("customerEmail");
        if (customerPhone) {
          await this.props.saveCustomerContact({
            name: customerName,
            phone: customerPhone,
            email: customerEmail,
          });
        }

        const block = params.get("block");
        const area_id = params.get("area_id");
        const country_id = params.get("country_id");
        const street = params.get("street");
        const building = params.get("building");
        const floor = params.get("floor");
        const apartment = params.get("apartment");
        const avenue = params.get("avenue");
        const additional = params.get("additional");
        const drawerBDC = params.get("branch_delivery_charge");
        const drawerBId = params.get("branch_id");
        if (drawerBDC) {
          await this.props.modifyAddress({
            block,
            street,
            building,
            floor,
            apartment,
            avenue,
            additional,
            selectedDeliveryType: 0,
            selectedAddressType: 0,
            area: parseInt(area_id),
            country: parseInt(country_id),
          });

          await this.props.setBranchDeliveryCharge({
            bdc: parseInt(drawerBDC),
            branch: parseInt(drawerBId),
            isPickup: false,
          });
        }
      } else {
        localStorage.removeItem("orderPlacedById");
      }

      tn = params.get("tn");
      const parkingNumber =
        params.get("pn") ||
        tn ||
        this.props.customer?.address?.token ||
        this.props.customer?.address?.parkingNumber;
      let branchID = params.get("b");
      if (branchID === "0") {
        this.props.resetLocalStorage();
        this.props.history.replace("/");
        window.location.reload(true);
        branchID = null;
      }
      let shouldFetchBranch = false;
      let qrCodeValid = false;
      let sessionID = null;
      if (parkingNumber) {
        if (!branchID)
          branchID = String(
            this.props.branch?.branch ||
              this.props.customer?.address?.pickupArea,
          );
        if (!branchID || branchID === "undefined" || branchID === "null") {
          try {
            const res = await instance.get("/should_fetch_branch/");
            shouldFetchBranch = res.data.fetchBranch;
            if (shouldFetchBranch) {
              branchID = res.data.branchID;
              await this.props.setBranchDeliveryCharge({
                isPickup: true,
                branch: parseInt(branchID),
              });
              this.props.preselectBranch(branchID);
            }
          } catch (e) {
            shouldFetchBranch = false;
          }
        }
        try {
          const res = await instance.post("/scan_qr/", {
            parkingNumber:
              parkingNumber ||
              this.props.customer?.address?.token ||
              this.props.customer?.address?.parkingNumber,
            branchID: branchID,
          });
          shouldFetchBranch = res.data.fetchBranch;
          qrCodeValid = res.data.valid;
          sessionID = res.data.session_id;

          if (shouldFetchBranch) {
            await this.props.setBranchDeliveryCharge({
              isPickup: true,
              branch: parseInt(branchID),
            });
          } else shouldFetchBranch = false;
        } catch (e) {
          console.error(e);
          shouldFetchBranch = false;
          qrCodeValid = false;
          sessionID = null;
        }
      } else {
        if (branchID) {
          try {
            const res = await instance.post("/scan_qr/", {
              branchID: branchID,
            });
            shouldFetchBranch = res.data.fetchBranch;
            if (shouldFetchBranch) {
              await this.props.setBranchDeliveryCharge({
                isPickup: true,
                branch: parseInt(branchID),
              });
              this.props.preselectBranch(branchID);
            }
          } catch (e) {
            shouldFetchBranch = false;
          }
        } else if (!this.props.branch.branch) {
          try {
            const res = await instance.get("/should_fetch_branch/");
            shouldFetchBranch = res.data.fetchBranch;
            if (shouldFetchBranch) {
              branchID = res.data.branchID;
              await this.props.setBranchDeliveryCharge({
                isPickup: true,
                branch: parseInt(branchID),
              });
              this.props.preselectBranch(branchID);
            }
          } catch (e) {
            shouldFetchBranch = false;
          }
        }
      }

      if (params.get("cart")) {
        await this.props.loadCart(
          params.get("cart"),
          this.props.history,
          params.get("new_address"),
        );
      }

      if (!this.props.branch.branch && !shouldFetchBranch) {
        await this.props.fetchStore(
          this.props.cart,
          this.props.applied_promo,
          this.props.history,
          null,
          qrCodeValid,
        );
      } else if (this.props.branch.branch || shouldFetchBranch) {
        await this.props.fetchBranch(
          this.props.branch.isPickup == false && !shouldFetchBranch
            ? "delivery"
            : "pickup",
          this.props.branch.isPickup == false && !shouldFetchBranch
            ? this.props.branch.bdc
            : this.props.branch.branch || branchID,
          this.props.cart,
          this.props.applied_promo,
          this.props.history,
          null,
          qrCodeValid,
          this.props.branch.branch || branchID,
        );
      }

      if (this.props.store) {
        await this.refreshOrderPassStorefrontData();
        if (this.shouldShowSignUpModal()) {
          this.setState({ signUpModalOpen: true });
        }
        if (
          !this.props.store.settings.is_branch_based_ordering &&
          this.props.branch.branch
        ) {
          this.props.clearBranch();
          this.props.clearStore();
          this.props.clearCart();
          window.location.reload();
          return;
        } else if (
          this.props.store.settings.is_branch_based_ordering &&
          !this.props.branch.branch &&
          this.props.settings.branch_count !== 1 &&
          !canAddToCartBeforeBranchSelection(this.props.store.settings)
        ) {
          this.props.clearCart();
        }
        const settings = this.props.store.settings;

        if (settings.enable_table_qr && qrCodeValid && tn) {
          let dineInExpirationTime = new Date().getTime() + 60000 * 120;
          localStorage.setItem("dineInExpirationTime", dineInExpirationTime);
          localStorage.setItem("dineInSessionID", sessionID);
          const dineInExpirationTimeFromStorage = localStorage.getItem(
            "dineInExpirationTime",
          );
          this.props.modifyAddress({
            dineInExpirationTime: dineInExpirationTime,
            dineInSessionID: sessionID,
          });
          try {
            if (!dineInExpirationTimeFromStorage) {
              instance.post("log_error/", {
                title: "Dine in Fail Set Token",
                server_open_date: this.props.store.today_date,
                agent: navigator.userAgent,
                url: window.location.href,
                dineInExpirationTime: dineInExpirationTimeFromStorage,
              });
            }
          } catch (error) {}
        }

        if (settings.enable_fb_pixel && settings.fb_pixel) {
          EnableFaceBook(settings, this.props.customerContact);
        }
        const params = new URLSearchParams(document.location.search);
        const fbclid = params.get("fbclid"); //facebook id
        const ttclid = params.get("ttclid"); //tiktok id
        const sccid = params.get("ScCid"); // snpchat id
        const epik = params.get("epik"); // pinterest id

        if (fbclid) {
          const fbc = `fb.1.${Date.now()}.${fbclid}`;
          localStorage.setItem("fbc_2", fbc);
        }

        if (settings.enable_snap_pixel && settings.snap_pixel) {
          if (sccid) {
            localStorage.setItem("sccid", sccid);
          }
          EnableSnapChat(settings.snap_pixel, settings.snapchat_email || "");
        }

        if (settings.enable_pinterest && settings.pinterest_pixel) {
          if (epik) {
            localStorage.setItem("epik", epik);
          }
          PinterestPixel.init(settings.pinterest_pixel);
          PinterestPixel.track("pagevisit");
        }

        if (settings.enable_twitter_pixel && settings.twitter_pixel) {
          settings.twitter_events =
            JSON.parse(settings.twitter_events || "{}") || {};
          TwitterPixel.init(settings.twitter_pixel);

          if (settings.twitter_events["Page View"]) {
            TwitterPixel.track(settings.twitter_events["Page View"]);
          }
        }

        if (settings.enable_google_analytics && settings.google_analytics) {
          EnableGoogle(settings.google_analytics);
          this.props.history.listen((location, action) => {
            ReactGA.send({
              hitType: "pageview",
              page: window.location.pathname + window.location.search,
            });
          });
        }
        if (settings.enable_klaviyo && settings.klaviyo_company_id) {
          Klaviyo.init(settings.klaviyo_company_id);
        }

        if (settings.enable_google_manager && settings.google_manager_id) {
          EnableGoogleTagManager(settings.google_manager_id);
        }

        if (settings.enable_ackoo && settings.ackoo_api_key) {
          const params = new URLSearchParams(this.props.location.search);
          const token = params.get("session-token");
          if (token) {
            EnableAckoo(settings.ackoo_api_key);
          }
        }

        if (canUseSocialAuth(settings)) {
          this.props.createCustomerWithAddressAndPhone();
        }
        if (
          settings.enable_google_ads_tracker &&
          settings.google_ads_conversion_id &&
          settings.google_ads_conversion_label
        ) {
          GoogleAdsTracker.init("AW-" + settings.google_ads_conversion_id);
        }
        if (settings.enable_tiktok_pixel && settings.tiktok_pixel) {
          TiktokPixel.init(settings.tiktok_pixel);
          if (ttclid) {
            localStorage.setItem("ttclid", ttclid);
          }
        }
      }
    }

    const search = this.props.location.search;
    if (search || this.props.applied_promo) {
      this.TryApplyPromo(search, this.props.applied_promo);
    }
  };

  componentDidUpdate = (prevProps) => {
    const storeLoaded = this.props.store && !prevProps.store;
    const verifiedPhoneChanged =
      prevProps.customer?.orderPassVerifiedPhone !==
      this.props.customer?.orderPassVerifiedPhone;

    if (storeLoaded || verifiedPhoneChanged) {
      this.refreshOrderPassStorefrontData();
    }
    if (this.props.store != prevProps.store && prevProps.store != null) {
      this.props.setBranchLoadingFalse();
    }
    if (
      this.props.branch?.branch !== prevProps.branch?.branch &&
      sessionStorage.getItem("promo_code") &&
      !this.props.applied_promo
    ) {
      {
        this.TryApplyPromo(sessionStorage.getItem("promo_code"));
      }
    }
  };

  shouldShowSignUpModal = () => {
    const { settings, main_cart, store, auth } = this.props;
    if (!store || !settings) return false;
    if (
      settings.is_branch_based_ordering &&
      (this.props.history.location.pathname === "/select/branch" ||
        this.props.history.location.pathname === "/join")
    )
      return false;
    if (auth.user || !canUseSocialAuth(settings)) {
      localStorage.removeItem("signUpCount");
      return false;
    }

    if (settings.is_menu) return false;

    let num = parseInt(localStorage.getItem("signUpCount"));
    localStorage.setItem("signUpCount", parseInt(num || 1) + 1);
    if (!num && main_cart.cart.length) return true;
    if (!num) {
      return false;
    }
    num = parseInt(num);
    if (num == 2 || num % 10 == 0) return true;

    return false;
  };
  getMetaDescription = () => {
    const { store } = this.props;
    if (!store) return "";
    return (
      store.meta_description.substring(0, 160) ||
      store.slogan.substring(0, 160) ||
      `Order online directly from ${store.name}`
    );
  };
  getMetaTitle = () => {
    const { language, store } = this.props;
    if (!store) return "";
    if (language == "arabic") {
      return (
        store.meta_name.substring(0, 160) || store.ar_name.substring(0, 160)
      );
    }
    return store.meta_name.substring(0, 160) || store.name.substring(0, 160);
  };

  checkB2Broute = () => {
    const { pathname } = this.props.location;
    const { distributor_slug } = this.props.store.settings;

    if (distributor_slug && distributor_slug.length > 0) {
      const isB2B = [...distributor_slug, "distributor"].some((slug) =>
        pathname.includes(slug),
      );
      if (isB2B) {
        return true;
      }
    } else {
      return false;
    }
  };

  render() {
    const {
      settings,
      isNotificationDismissed,
      address,
      language,
      cartSmartPromos,
    } = this.props;

    if (
      !this.props.store ||
      this.props.branch.loading ||
      (window.location.pathname.startsWith("/category") &&
        this.props.secondLoading)
    )
      return (
        <Suspense fallback={<></>}>
          <Loading />
        </Suspense>
      );
    const showBanner =
      settings.enable_banner &&
      !this.props.isNotificationDismissed &&
      !this.props.isB2BNoticeBannerVisible;

    const showBannerB2B =
      (this.props.distributorNoticeBannerOverride
        ? this.props.distributorNoticeBanner
        : this.props.settings.enable_banner_b2b) &&
      !this.props.isNotificationDismissedB2B;

    const showPopupBanner = settings.enable_popup_banner;
    const theme = createMuiTheme({
      palette: {
        primary: {
          main: this.props.store.settings.dark
            ? this.props.store.settings.dark
            : "#0099cc",
        },
      },
      typography: {
        fontFamily: ["Quicksand", "Cairo"].join(","),
      },
      overrides: {
        // Style sheet name ⚛️
        MuiDrawer: {
          // Name of the rule
          paperAnchorBottom: {
            // Some CSS
            left: this.props.language == "english" ? 0 : "auto !important",
          },
        },
      },
    });

    let ios =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    let insta = navigator.userAgent.match(/instagram/i);
    insta = false; //

    const { signUpModalOpen } = this.state;

    const callAWaiter = async () => {
      try {
        const res = await instance.post("/customer_at_location/", {
          table_number: address?.token,
        });
        this.setState({ alertOpen: true });
      } catch (e) {
        console.error(e);
      }
    };

    const enable_ebutler_widget =
      settings.enable_ebutler_widget_staff &&
      settings.enable_ebutler_widget &&
      settings.link_ebutler;

    return (
      <MuiThemeProvider theme={theme}>
        <Helmet>
          <title>{this.getMetaTitle()}</title>
          <meta name="description" content={this.getMetaDescription()} />
          <link rel="canonical" href={window.location.href} />
        </Helmet>

        {signUpModalOpen && (
          <SignUpModal
            open={true}
            onClose={() => this.setState({ signUpModalOpen: false })}
          />
        )}

        {this.state.openWaiterDialog && (
          <CallWaiterDiolog
            onClose={() => this.setState({ openWaiterDialog: false })}
            onClick={() => {
              callAWaiter();
              this.setState({ openWaiterDialog: false });
            }}
            language={language}
          />
        )}
        {address?.token &&
          settings?.enable_table_qr &&
          settings.enable_pickup_arrival_requests &&
          this.props.history.location.pathname !== "/" && (
            <Fab
              size="small"
              color="primary"
              aria-label="call-waiter"
              onClick={() => this.setState({ openWaiterDialog: true })}
              style={{
                position: "fixed",
                top: 70,
                right: 10,
                zIndex: 999999,
              }}
            >
              <RoomServiceIcon />
            </Fab>
          )}

        <Snackbar
          open={this.state.alertOpen}
          autoHideDuration={3000}
          onClose={() => this.setState({ alertOpen: false })}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert
            onClose={() => this.setState({ alertOpen: false })}
            severity="success"
          >
            {language == "english"
              ? "A waiter has been notified!"
              : "تم ارسال اشعار لموظفي الخدمة"}
          </Alert>
        </Snackbar>

        <WhatsAppWidget />
        <InstagramWidget />
        <TikTokWidget />

        {enable_ebutler_widget && <EbutlerWidget />}

        {this.props.store.smart_promos.length > 0 &&
          !this.props.isB2B &&
          !this.checkB2Broute() &&
          (cartSmartPromos?.products?.length > 0 ||
            cartSmartPromos?.category_free?.length > 0) && <PromotionMessage />}

        <div
          className={"App container-fluid h-100 "
            .concat(
              this.props.language == "english" ? "english-font" : "arabic-font",
            )
            .concat(window.location.pathname == "/" ? " grayBackground" : "")}
          id="main"
          ref={this.selector}
        >
          <div className="row" style={{ overflowY: "scroll" }}>
            {this.props.language == "arabic" && (
              <div
                className="col-lg-7 col-md-7 h-100 d-md-none d-sm-none d-xs-none d-none d-lg-block d-md-block p-0 m-0"
                style={{
                  backgroundColor: "gray",
                  position: "fixed",
                  left: 0,
                  top: 0,

                  zIndex: 55,
                }}
              >
                <Header imageSize={"full"} style={{ overflowY: "hidden" }} />
              </div>
            )}

            <div
              className={"col-lg-5 col-md-5 col-12 p-0 w-100 ".concat(
                this.props.language == "arabic" ? "ml-auto" : "",
              )}
              style={{
                marginTop:
                  showBanner ||
                  (this.props.isB2BNoticeBannerVisible ? showBannerB2B : false)
                    ? "50px"
                    : "",
                overflowY: "scroll",
                overflowX: "hidden",
                backgroundColor: "#f4f5f5",
                minHeight: "calc(100% - 60px )",
                height: "calc(100% - 60px)",
                // maxWidth: "42vw",
                // maxWidth: 400,
              }}
            >
              <NoticeBanner
                isB2B={this.props.isB2BNoticeBannerVisible}
                checkB2Broute={this.checkB2Broute()}
              />
              <div className="p-0 h-100">
                {!!this.props.settings &&
                  (!this.props.settings.is_menu ? (
                    <Switch>
                      <Route path="/select/branch" component={AreaSelect} />
                      <Route path="/join" component={Teasers} />
                      <Route
                        path="/:slug/distributor/product/:CategorySlug/:ProductSlug"
                        component={DistributorProductDetails}
                      />
                      <Route
                        path="/product/:CategorySlug/:ParentProduct?/:ProductSlug"
                        component={ProductDetails}
                      />

                      <Route
                        path="/product/:ProductId"
                        component={ProductDetails}
                      />
                      <Route
                        path="/category/:categorySlug?"
                        component={CategoryDetailList}
                      />
                      <Route path="/checkout/details" component={FirstStep} />
                      <Route path="/Topup" component={WalletTopupProcess} />
                      {this.props.store.settings.show_waiting_lists && (
                        <Route
                          exact
                          path="/waitlist"
                          component={WaitListForm}
                        />
                      )}
                      {this.props.store.settings.show_waiting_lists && (
                        <Route
                          exact
                          path="/waitlist/track"
                          component={WaitList}
                        />
                      )}
                      {this.props.store.settings.show_waiting_lists && (
                        <Route
                          exact
                          path="/waitlist/status"
                          component={WaitListStatus}
                        />
                      )}
                      <Route
                        path="/checkout/address/map"
                        component={MapPickerPage}
                      />
                      <Route path="/checkout/address" component={SecondStep} />
                      <Route
                        path="/branch/:branchID"
                        component={BranchDetail}
                      />
                      <Route
                        path="/checkout/confirmation"
                        component={Confirmation}
                      />
                      <Route path="/contact" component={Branches} />
                      {this.props.store.settings.enable_tracking && (
                        <Route
                          path="/track/order/:tracking_id?/review"
                          component={ProductFeedbackPage}
                        />
                      )}

                      {this.props.store.settings.enable_tracking && (
                        <Route
                          path="/track/order/:tracking_id?"
                          component={TrackingPage}
                        />
                      )}
                      {this.props.store.settings.enable_tracking && (
                        <Route
                          path="/distributor/track/order/:tracking_id?"
                          component={DistributorOrderTracking}
                        />
                      )}
                      <Route path="/success/:Tid?" component={PaymentSuccess} />

                      <Route path="/fail/:Tid?/:pm?" component={PaymentFail} />
                      <Route
                        path="/distributor/success"
                        component={DistributorSuccess}
                      />
                      <Route
                        path="/distributor/fail"
                        component={DistributorFail}
                      />
                      <Route path="/track/previous" component={PastOrders} />
                      <Route
                        path="/download/:tracking_id?"
                        component={DigitalDownload}
                      />
                      {this.props.store.settings.enable_search && (
                        <Route path="/search" component={Search} />
                      )}
                      {canUseSocialAuth(settings) && (
                          <Route
                            path="/profile/email-signin"
                            component={EmailSignin}
                          />
                        )}

                      {canUseSocialAuth(settings) &&
                        settings.enable_phone_login && (
                          <Route
                            path="/profile/phone-signin"
                            component={PhoneSignin}
                          />
                        )}

                      {canUseSocialAuth(settings) && (
                          <Route
                            path="/profile/forgot-password"
                            component={EmailForgotPassword}
                          />
                        )}

                      {canUseSocialAuth(settings) &&
                        settings.enable_phone_login && (
                          <Route
                            path="/profile/forgot-password-phone"
                            component={PhoneForgotPassword}
                          />
                        )}

                      <Route path="/profile" component={Profile} />
                      <Route path="/wallet" component={Wallet} />
                      {(settings.enable_aseer_time ||
                        settings.enable_loyalty_points_page) && (
                        <Route path="/rewards" component={LoyaltyHomePage} />
                      )}

                      <Route
                        path="/favorites"
                        component={FavoriteProductPage}
                      />
                      <Route path="/points" component={Points} />
                      <Route path="/cart" component={Cart} />
                      {settings.enable_static_pages && (
                        <Route
                          path="/page/:slug"
                          render={(props) => (
                            <HomePage {...props} appRef={this.selector} />
                          )}
                        />
                      )}

                      <Route
                        path={`/:slug`}
                        exact
                        render={(props) => (
                          <B2B {...props} appRef={this.selector} />
                        )}
                      />
                      <Route
                        path="/"
                        render={(props) => (
                          <HomePage {...props} appRef={this.selector} />
                        )}
                      />
                    </Switch>
                  ) : (
                    <Switch>
                      <Route
                        path="/product/:CategorySlug/:ParentProduct?/:ProductSlug"
                        component={ProductDetails}
                      />
                      <Route
                        path="/product/:ProductId"
                        component={ProductDetails}
                      />
                      <Route
                        path="/category/:categorySlug?"
                        component={CategoryDetailList}
                      />
                      <Route path="/contact" component={Branches} />
                      <Route path="/select/branch" component={AreaSelect} />
                      <Route
                        path="/branch/:branchID"
                        component={BranchDetail}
                      />
                      {this.props.store.settings.enable_tracking &&
                        (this.props.settings.enable_car_qr ||
                          this.props.settings.enable_table_qr) && (
                          <Route
                            path="/track/order/:tracking_id?"
                            component={TrackingPage}
                          />
                        )}
                      {(this.props.settings.enable_car_qr ||
                        this.props.settings.enable_table_qr) && (
                        <Route
                          path="/success/:Tid?"
                          component={PaymentSuccess}
                        />
                      )}
                      {(this.props.settings.enable_car_qr ||
                        this.props.settings.enable_table_qr) && (
                        <Route
                          path="/fail/:Tid?/:pm?"
                          component={PaymentFail}
                        />
                      )}

                      {this.props.store.settings.enable_search && (
                        <Route path="/search" component={Search} />
                      )}

                      {this.props.store.settings.show_waiting_lists && (
                        <Route
                          exact
                          path="/waitlist"
                          component={WaitListForm}
                        />
                      )}
                      {this.props.store.settings.show_waiting_lists && (
                        <Route
                          exact
                          path="/waitlist/track"
                          component={WaitList}
                        />
                      )}
                      {this.props.store.settings.show_waiting_lists && (
                        <Route
                          exact
                          path="/waitlist/status"
                          component={WaitListStatus}
                        />
                      )}
                      {settings.enable_static_pages && (
                        <Route
                          path="/page/:slug"
                          render={(props) => (
                            <HomePage {...props} appRef={this.selector} />
                          )}
                        />
                      )}

                      <Route
                        path="/"
                        render={(props) => (
                          <HomePage {...props} appRef={this.selector} />
                        )}
                      />
                    </Switch>
                  ))}
              </div>
              {(settings.enable_aseer_time ||
                settings.enable_loyalty_points_page) && (
                <Paper
                  className="d-lg-none d-xl-none d-md-none"
                  square
                  style={{
                    width: "100%",
                    position: "fixed",
                    bottom: -1,
                    zIndex: 100,
                  }}
                >
                  <Tabs
                    value={window.location.pathname}
                    onChange={(e, newValue) => {
                      // if (true || newValue !== this.state.currentTab) {
                      //   let newHomePageLink = this.state.lastHomePageLink;
                      //   if (this.state.currentTab == "homepage") {
                      //     newHomePageLink = window.location.pathname;
                      //   }
                      // this.setState({
                      //   currentTab: newValue,
                      //   lastHomePageLink: newHomePageLink,
                      // });

                      this.props.history.replace(newValue);
                      // this.props.history.replace(
                      //   (newValue === "homepage" && newHomePageLink) || newValue
                      // );
                      // }
                    }}
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="icon tabs example"
                  >
                    <Tab icon={<MenuBook />} aria-label="menu" value={"/"} />

                    <Tab
                      icon={<Star />}
                      aria-label="rewards"
                      value={"/rewards"}
                    />

                    <Tab
                      icon={<Person />}
                      aria-label="profile"
                      value={"/profile"}
                    />
                  </Tabs>
                </Paper>
              )}
            </div>
            {showPopupBanner && !this.props.isB2B && !this.checkB2Broute() && (
              <PopupBanner isB2B={false} />
            )}
            {this.props.language == "english" && (
              <div
                className="col-lg-7 col-md-7 h-100 d-md-none d-sm-none d-xs-none d-none d-lg-block d-md-block p-0"
                style={{
                  backgroundColor: "gray",
                  overflowY: "hidden",
                  position: "fixed",
                  left: "41.64vw",
                  objectFit: "fill",
                }}
              >
                <Header imageSize={"full"} />
              </div>
            )}
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    labels: state.store.labels,
    store: state.store.store,
    cart: state.cart.cart,
    main_cart: state.cart,
    price: state.cart.price,
    applied_promo: state.cart.promos,
    branch: state.branch,
    customer: state.customers,
    categories: state.store.store ? state.store.store.categories : [],
    current_product: state.store.current_product,
    secondLoading: state.store.secondLoading,
    settings: state.store.store ? state.store.store.settings : {},
    isNotificationDismissed: state.store.isNotificationDismissed,
    auth: state.auth,
    address: state.customers.address,
    isB2BNoticeBannerVisible: state.b2b.isB2BNoticeBannerVisible,
    isNotificationDismissedB2B: state.b2b.isNotificationDismissedB2B,
    distributorNoticeBanner: state.b2b.distributorNoticeBanner,
    distributorNoticeBannerOverride: state.b2b.distributorNoticeBannerOverride,
    isB2B: state.store.isB2B,
    cartSmartPromos: state.cart?.discounts,
    channel: state.promise.src,
    customerContact: state.customers?.customerContact,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchStore: (cart, promo, history, forceCurrency, qrCodeValid) =>
      dispatch(fetchStore(cart, promo, history, forceCurrency, qrCodeValid)),
    setLanguage: (lan) => dispatch(setLanguage(lan)),
    fetchBranch: (
      type,
      bdc_id,
      cart,
      promo,
      history,
      forceCurrency,
      qrCodeValid,
      branchID,
    ) =>
      dispatch(
        fetchBranch(
          type,
          bdc_id,
          cart,
          promo,
          history,
          forceCurrency,
          qrCodeValid,
          branchID,
        ),
      ),
    setBranchLoadingFalse: () => dispatch({ type: "SET_BRANCH_LOADING_FALSE" }),
    clearStore: () => dispatch({ type: "CLEAR_STORE" }),
    clearBranch: () => dispatch({ type: "CLEAR_BRANCH" }),
    clearCart: () => dispatch(clearCart()),
    resetLocalStorage: () => dispatch(resetLocalStorage()),
    Apply_Promo: (promo) => dispatch(Apply_Promo(promo)),
    setUser: (key, history) => dispatch(setUser(key, history)),
    createCustomerWithAddressAndPhone: () =>
      dispatch(createCustomerWithAddressAndPhone()),
    setBranchDeliveryCharge: (data) => dispatch(setBranchDeliveryCharge(data)),
    preselectBranch: (branchID) =>
      dispatch({
        type: "MODIFY_ADDRESS",
        payload: {
          selectedDeliveryType: 1,
          pickupArea: parseInt(branchID),
          area: null,
          country: null,
          gpsConfirmed: false,
          lat: "",
          lng: "",
          block: "",
          street: "",
        },
      }),
    loadCart: (cart_uuid, history, new_address) =>
      dispatch(loadCart(cart_uuid, history, new_address)),
    setFromMobile: () => dispatch({ type: "SET_FROM_MOBILE" }),
    resetCustomersReducer: () => dispatch({ type: "RESET_CUSTOMERS_REDUCER" }),
    saveCustomerContact: (customer) => dispatch(saveCustomerContact(customer)),
    clearOrderPassData: () => dispatch(clearOrderPassData()),
    refreshStorefrontOrderPassData: () =>
      dispatch(refreshStorefrontOrderPassData()),

    modifyAddress: (address) =>
      dispatch({ type: "MODIFY_ADDRESS", payload: address }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
